var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuitarAmp = function SvgGuitarAmp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M22.667 4C20.82 4 18.769 2.667 16 2.667 13.23 2.667 12.102 4 9.333 4M2.667 14.667h26.666M4 28l4-4m0 0 4-4m-4 4 4 4 4-4m-8 0-4-4 4-4 4 4m0 0 4-4 4 4m-8 0 4 4m12 4-4-4m0 0-4-4m4 4-4 4-4-4m8 0 4-4-4-4-4 4m0 0-4 4M4 29.333h24c.736 0 1.333-.597 1.333-1.333V8c0-.736-.597-1.333-1.333-1.333H4c-.737 0-1.333.597-1.333 1.333v20c0 .736.596 1.333 1.333 1.333Z"
  })));
};
export default SvgGuitarAmp;